const configEn = {
  title: "Let's discuss your project!",
  subtitle: 'Please specify your current business demands:',
  sections: [
    {
      id: 'price-custom-software',
      button: 'Custom software',
      summaryTitle: 'Business need',
      steps: [
        {
          block: 'TagsGroup',
          type: 'radio',
          label: 'development_direction',
          title: 'Choose the type of software solution you need:',
          summaryTitle: 'Solution type',
          options: ['Mobile', 'Web', 'Mobile and web'],
        },
        {
          block: 'TagsGroup',
          type: 'radio',
          label: 'stage',
          title: 'Choose the current stage of your project:',
          summaryTitle: 'Current stage',
          options: ['Idea', 'Technical documentation', 'MVP', 'Working solution'],
        },
      ],
    },
    {
      id: 'price',
      button: 'Team augmentation',
      summaryTitle: 'Business need',
      steps: [
        {
          block: 'CounterGroup',
          label: 'development-team',
          type: 'counter',
          title: 'Specify the type and number of specialists you need:',
          summaryTitle: 'Specialists',
          options: [
            'Front-end developer',
            'Back-end developer',
            'Mobile developer',
            'Solution architect',
            'Project manager',
            'UI/UX designer',
            'DevOps engineer',
            'QA engineer',
            'Business analyst',
            'Graphic Designer',
          ],
        },
        {
          block: 'TagsGroup',
          label: 'duration',
          type: 'radio',
          title: 'Your planned engagement duration:',
          summaryTitle: 'Duration',
          options: ['1-3', '4-6', '7-8', '9-12', '12+'],
        },
      ],
    },
  ],
};
const configDe = {
  title: 'Lassen Sie uns Ihr Projekt besprechen',
  subtitle: 'Aktuellen Bedarf angeben:',
  sections: [
    {
      id: 'price-custom-software',
      button: 'Individuelle Software',
      summaryTitle: 'Geschäftsbedarf',
      steps: [
        {
          block: 'TagsGroup',
          type: 'radio',
          label: 'development_direction',
          title: 'Art der Softwarelösung wählen:',
          summaryTitle: 'Lösungsart',
          options: ['Mobile', 'Web', 'Mobile und Web'],
        },
        {
          block: 'TagsGroup',
          type: 'radio',
          label: 'stage',
          title: 'Stand des Projekts wählen:',
          summaryTitle: 'Aktueller Stand',
          options: ['Idee', 'Technische Dokumentation', 'MVP', 'Funktionsfähige Lösung'],
        },
      ],
    },
    {
      id: 'price',
      button: 'Team Augmentation',
      summaryTitle: 'Geschäftsbedarf',
      steps: [
        {
          block: 'CounterGroup',
          label: 'development-team',
          type: 'counter',
          title: 'Typ und Anzahl der benötigten Spezialisten angeben:',
          summaryTitle: 'Spezialisten',
          options: [
            'Frontend-Entwickler',
            'Backend-Entwickler',
            'Mobile-Entwickler',
            'Lösungsarchitekt',
            'Projektmanager',
            'UI/UX-Designer',
            'DevOps-Ingenieur',
            'QS-Ingenieur',
            'Business-Analyst',
            'Grafikdesigner',
          ],
        },
        {
          block: 'TagsGroup',
          label: 'duration',
          type: 'radio',
          title: 'Geplante Dauer Ihres Engagements:',
          summaryTitle: 'Dauer',
          options: ['1-3', '4-6', '7-8', '9-12', '12+'],
        },
      ],
    },
  ],
};

export const getConfig = lang => {
  if (lang === 'de') {
    return configDe;
  }

  return configEn;
};
